import DashboardIcon from "assets/svg/navigation/dashboard-icon.svg";
import UserIcon from "assets/svg/navigation/user-icon.svg";
import TransactionsIcon from "assets/svg/navigation/transactions-icon.svg";
import ComplianceIcon from "assets/svg/navigation/compliance-icon.svg";
import CharityIcon from "assets/svg/navigation/charity-icon.svg";
import CurrencyIcon from "assets/svg/navigation/currency-icon.svg";
import ExchangeRatesIcon from "assets/svg/navigation/exchange-rates-icon.svg";
import BeneficiaryIcon from "assets/svg/navigation/beneficiary-icon.svg";
import MarketingIcon from "assets/svg/navigation/marketing-icon.svg";
import { ROUTES } from "constants/routes";

export const navData: INavigationData[] = [
  {
    text: "Dashboard",
    icon: DashboardIcon,
    link: ROUTES.DASHBOARD.path,
  },
  {
    text: "Users",
    icon: UserIcon,
    link: ROUTES.USERS.path,
  },
  {
    text: "Transactions",
    icon: TransactionsIcon,
    link: ROUTES.TRANSACTIONS.path,
  },
  {
    text: "Bamboo Transfers",
    icon: TransactionsIcon,
    link: ROUTES.BAMBOO_TRANSFERS.path,
  },
  {
    text: "Exchange Rates",
    icon: ExchangeRatesIcon,
    link: ROUTES.EXCHANGE_RATES.path,
  },
  {
    text: "Currencies",
    icon: CurrencyIcon,
    link: ROUTES.CURRENCIES.path,
  },
  {
    text: "Beneficiaries",
    icon: BeneficiaryIcon,
    link: ROUTES.BENEFICIARIES.path,
  },
  {
    text: "Compliance",
    icon: ComplianceIcon,
    link: ROUTES.FLAGGED_USERS.path,
  },
  {
    text: "Charity",
    icon: CharityIcon,
    link: ROUTES.CHARITY.path,
  },
  {
    text: "Marketing",
    icon: MarketingIcon,
    link: ROUTES.MARKETING.path,
    children: [
      { text: "Overview", link: ROUTES.MARKETING_OVERVIEW.path },
      { text: "Partners", link: ROUTES.PARTNERS.path },
      { text: "Vouchers", link: ROUTES.VOUCHERS.path },
      { text: "Redemptions", link: ROUTES.REDEMPTIONS.path },
    ],
  },
  {
    text: "Audit Trail",
    icon: ComplianceIcon,
    link: ROUTES.AUDIT_TRAIL.path,
  },
];
